import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Button, Space, Spin, Select, message } from "antd";
import { formatPolishCurrency } from "../../../helpers/currency";
import {
  getLoggedAccountTransactionRoleId,
  getAuthToken,
} from "../../../helpers/account";
import { api } from "../../../config/api";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

const LoadEscrowAction = (props) => {
  const { t } = useTranslation();
  const [clientSecret, setClientSecret] = useState("");
  const [loading, setLoading] = useState(false);
  const [accountantData, setAccountantData] = useState(null);
  const [rewards, setRewards] = useState([]);
  const [selectedReward, setSelectedReward] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    // Fetch rewards data
    const fetchRewards = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${api.host}/rewards`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${getAuthToken()}`,
          },
        });
        const data = await response.json();
        setRewards(data);
      } catch (error) {
        console.error("Failed to fetch rewards:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRewards();
  }, []);

  const canBeRendered =
    props.transaction &&
    getLoggedAccountTransactionRoleId(props.transaction) === 2 &&
    props.transaction.agreement_accepted_by_initiator &&
    props.transaction.agreement_accepted_by_counterparty &&
    !props.transaction.escrow_received;

  const appearance = {
    theme: "stripe",
  };
  const handleSaveReward = async () => {
    if (!selectedReward) {
      message.error(t('transaction.actions.selectGiftCard'));
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${api.host}/rewards/assign/${selectedReward}/${props.transaction.uuid}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${getAuthToken()}`,
          },
        }
      );

      if (response.ok) {
        message.success(t('transaction.actions.cardAssigned'));
        dispatch({
          type: "transactionDataUpdated",
          payload: {
            transactionDataChanged: new Date().getSeconds(),
          },
        });
      }
    } catch (error) {
      console.error("Error saving reward:", error);
      message.error(t('transaction.actions.cardSaveError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    canBeRendered && (
      <Space direction="vertical">
        {loading && <Spin />}

        <Alert
          type="warning"
          message={
            <>
              {t('transaction.actions.assignGiftCardMinValue')}{" "}
              {formatPolishCurrency(props.transaction.escrow_amount_total)}
            </>
          }
        />

        <Space direction="vertical" style={{ width: "100%" }}>
          <Select
            placeholder={t('transaction.actions.selectGiftCardPlaceholder')}
            style={{ width: "100%", maxWidth: "400px" }}
            value={selectedReward}
            onChange={setSelectedReward}
            options={rewards.map((reward) => ({
              value: reward.uuid,
              label: `${reward.name} - ${formatPolishCurrency(reward.value)}`,
            }))}
          />
          <Button type="primary" onClick={handleSaveReward} loading={loading}>
            {t('transaction.actions.addCardToEscrow')}
          </Button>
        </Space>
      </Space>
    )
  );
};

export default LoadEscrowAction;
